import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import ProgressControl from './ProgressControl';
import PlayToggle from './PlayToggle';
import AudioOnly from './AudioOnly';
import Live from './Live';
import SettingMenu from './SettingMenu';
import FullscreenToggle from './FullscreenToggle';
import CurrentTimeDisplay from '../time-controls/CurrentTimeDisplay';
import DurationDisplay from '../time-controls/DurationDisplay';
import TimeDivider from '../time-controls/TimeDivider';
import VolumeMenuButton from './VolumeMenuButton';
import PlaybackRateMenuButton from './PlaybackRateMenuButton';
import { mergeAndSortChildren } from '../../utils';

const propTypes = {
  children: PropTypes.any,
  autoHide: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  autoHide: true,
};

export default class ControlBar extends Component {
  constructor(props) {
    super(props);
  }

  getChildren() {
    const children = React.Children.toArray(this.props.children);
    return mergeAndSortChildren([], children, this.props);
  }

  render() {
    const { autoHide, className, player: { hasDVR, isLive, tracks, switchingTrack, activeTrack, realActiveTrack, playbackRate } } = this.props;
    const children = this.getChildren();

    return (
      <div
        className={classNames('video-react-control-bar', {
          'video-react-control-bar-auto-hide': autoHide
        }, className)}
      >
        {(!isLive || hasDVR) &&
          <div className="video-react-control-bar-progress-bar">
            <ProgressControl
              {...this.props}
              key="progress-control"
              order={1}
            />
          </div>
        }
        <div className="video-react-control-bar-buttons">
          <div className="video-react-control-left">
            <PlayToggle
              {...this.props}
              key="play-toggle"
              order={2}
            />
            <VolumeMenuButton
                {...this.props}
                key="volume-menu-button"
                order={3}
            />
            {!isLive
              ? <div className="video-react-control-time-display">
                  <CurrentTimeDisplay
                    {...this.props}
                    key="current-time-display"
                    order={4}
                  />
                  <TimeDivider
                    {...this.props}
                    key="time-divider"
                    order={5}
                  />
                  <DurationDisplay
                    {...this.props}
                    key="duration-display"
                    order={6}
                  />
                </div>
              : <Live
                  {...this.props}
                  key="live-indicator"
                  order={7}
                />
            }
          </div>
          <div className="video-react-control-right">
            {children}
            <AudioOnly
              {...this.props}
              key="audio-only"
              order={8}
            />
            <SettingMenu
                {...this.props}
                rates={[0.5, 0.75, 1, 1.25, 1.5]}
                activeTrack={activeTrack}
                switchingTrack={switchingTrack}
                realActiveTrack={realActiveTrack}
                tracks={tracks}
                isLive={isLive}
                playbackRate={playbackRate}
                key="settings"
                order={10}
            />
            <FullscreenToggle
              {...this.props}
              key="fullscreen-toggle"
              order={11}
            />
          </div>
        </div>
      </div>
    );
  }
}

ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';
